import React from 'react'
import {FieldConfig, useField} from 'formik'
import {Checkbox} from '~/src/design-system/BaseComponents'
import styled from 'styled-components'

const ErrorText = styled.span`
  color: var(--error-main, #ff6760);
  font-size: 0.75rem;
  margin-top: var(--space-1);
`

const FormikCheckboxWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

interface ICheckbox {
  name?: string
  label?: string
  disabled?: boolean
  indeterminate?: boolean
  checked?: boolean
  size?: 'small' | 'medium'
  'data-testid'?: string
  [key: string]: unknown
}

export default function FormikCheckbox(props: ICheckbox) {
  const {label = '', ...rest} = props
  const [field, meta] = useField({...rest, type: 'checkbox'} as FieldConfig)
  const errorMsg = meta.touched && meta.error ? meta.error : ''

  return (
    <FormikCheckboxWrapper data-testid="formik-checkbox">
      <Checkbox
        {...field}
        checked={field.checked}
        disabled={props.disabled}
        indeterminate={props.indeterminate}
        label={label || undefined}
        data-testid={props['data-testid']}
      />
      {errorMsg && <ErrorText>{errorMsg}</ErrorText>}
    </FormikCheckboxWrapper>
  )
}
